<!-- ⚠️ AQUI NO HAY `@if` DE SESION, Y ESO ES LA CORRECCION DE UN PARPADEO.
     El marco con sesion es una RUTA PADRE (`ShellLayout`), asi que el router lo
     monta y lo desmonta como parte de la navegacion, de una sola vez. Cuando la
     decision vivia aqui, el `@if` la tomaba el estado de SESION y el contenido
     lo ponia el ROUTER: al entrar se veia el login DENTRO del layout, y al salir
     el layout desaparecia antes que la pagina. Ver el docblock de `ShellLayout`. -->
<router-outlet />

<!-- Visor global de archivos: UNICA instancia en toda la app (se invoca via
     FileViewerService). Va en la raiz —fuera del marco— porque tambien tiene que
     poder abrirse desde una pantalla sin sesion. -->
<intelishs-file-viewer />

<!-- ── Velo de espera ────────────────────────────────────────────────────────
     Pantalla completa, para las esperas que BLOQUEAN: el cierre de sesion y una
     navegacion que todavia no tiene nada que pintar.

     Va en la RAIZ y no dentro del marco a proposito: tiene que seguir cubriendo
     mientras el router intercambia el marco por el login, que es justo el
     momento en que el usuario se queda sin referencia visual. -->
<!-- Sin entradas: el velo lee `OverlayCargaService`. Quien enciende una carga
     recibe su propio apagador, asi que dos operaciones a la vez no se pisan. -->
<intelishs-overlay-carga />
